import { defaultFileMiniProgramSharePlaceholderUrl, defaultFileMiniProgramStructuredCoverUrl, defaultFileMiniProgramStructuredMessageUrl, matchMimeTypeToUrl, matchMimeTypeToPngUrl, matchMimeTypeToSharePlaceholderUrl, matchMimeTypeToStructuredCoverUrl, matchMimeTypeToStructuredMessageUrl, fileIconPngPath, matchMimeTypeToFavicon, defaultFaviconUrl } from "../util/const";
import { getConcatUrl, mimetypeAdaptor } from "../util/utils";
import { MatchMachine } from "../util/match-machine";
import { faviconUrl, iconPngUrl, iconUrl, sharePlaceholderUrl, structuredCoverUrl, structuredMessageUrl } from "../util/icons";
import { defaultFileIconUrl, cdnDomain } from "../util/const";
export var FileIconFormat = /*#__PURE__*/function (FileIconFormat) {
  FileIconFormat["SVG"] = "svg";
  FileIconFormat["PNG"] = "png";
  return FileIconFormat;
}({});
/**
 * 获取文件 icon 的 URL
 */
export function getFileIconURL(_ref) {
  var mimeType = _ref.mimeType,
    docType = _ref.docType,
    padType = _ref.padType,
    extensionName = _ref.extensionName,
    _ref$isCollaboration = _ref.isCollaboration,
    isCollaboration = _ref$isCollaboration === void 0 ? false : _ref$isCollaboration,
    size = _ref.size,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? FileIconFormat.SVG : _ref$format;
  // 适配存量文件没有 mimeType、mimeType 字段规范不统一的情况
  mimeType = mimetypeAdaptor({
    mimeType: mimeType,
    docType: docType,
    padType: padType,
    isCollaboration: isCollaboration,
    extensionName: extensionName
  });
  if (!size) {
    // 未传入 size 返回 svg 图标
    var _concatUrl = getConcatUrl(mimeType, format);
    var machine = format === FileIconFormat.PNG ? fileIconPngMm : fileIconSvgMm;
    return {
      target: machine.run(mimeType) || _concatUrl,
      fallback: defaultFileIconUrl
    };
  }
  // 传入 size 返回对应尺寸 png 图标，使用图片云的图像处理能力获得指定尺寸的 png 图片
  var suffix = "?imageView2/1/w/".concat(size);
  var concatUrl = cdnDomain + fileIconPngPath + mimeType + ".png";
  return {
    target: (fileIconPngMm.run(mimeType) || concatUrl) + suffix,
    fallback: defaultFileIconUrl + suffix
  };
}

/**
 * 小程序卡片态预览图场景下，获取 icon 的 URL
 */
export function getMiniProgramStructuredMessageUrl(_ref2) {
  var docType = _ref2.docType,
    mimeType = _ref2.mimeType,
    extensionName = _ref2.extensionName,
    padType = _ref2.padType;
  // 适配存量文件没有 mimeType、mimeType 字段规范不统一的情况
  mimeType = mimetypeAdaptor({
    mimeType: mimeType,
    docType: docType,
    padType: padType,
    extensionName: extensionName
  });
  return structuredMessageMm.run(mimeType) || defaultFileMiniProgramStructuredMessageUrl;
}

/**
 * 小程序分享确认界面场景下，获取预览 icon 的 URL
 */
export function getMiniProgramStructuredCoverUrl(_ref3) {
  var docType = _ref3.docType,
    mimeType = _ref3.mimeType,
    extensionName = _ref3.extensionName,
    padType = _ref3.padType;
  // 适配存量文件没有 mimeType、mimeType 字段规范不统一的情况
  mimeType = mimetypeAdaptor({
    mimeType: mimeType,
    docType: docType,
    padType: padType,
    extensionName: extensionName
  });
  return structuredCoverMm.run(mimeType) || defaultFileMiniProgramStructuredCoverUrl;
}

/**
 * 小程序分享页非 owner 文件场景下，获取分享占位符的 URL
 */
export function getMiniProgramSharePlaceholderUrl(_ref4) {
  var docType = _ref4.docType,
    mimeType = _ref4.mimeType,
    extensionName = _ref4.extensionName,
    padType = _ref4.padType;
  // 适配存量文件没有 mimeType、mimeType 字段规范不统一的情况
  mimeType = mimetypeAdaptor({
    mimeType: mimeType,
    docType: docType,
    padType: padType,
    extensionName: extensionName
  });
  return sharePlaceholderMm.run(mimeType) || defaultFileMiniProgramSharePlaceholderUrl;
}

/**
 * 浏览器tab Favicon
 */
export function getFaviconUrl(_ref5) {
  var docType = _ref5.docType,
    mimeType = _ref5.mimeType,
    extensionName = _ref5.extensionName,
    padType = _ref5.padType;
  // 适配存量文件没有 mimeType、mimeType 字段规范不统一的情况
  mimeType = mimetypeAdaptor({
    mimeType: mimeType,
    docType: docType,
    padType: padType,
    extensionName: extensionName
  });
  return faviconUrlMm.run(mimeType) || defaultFaviconUrl;
}
var fileIconSvgMm = new MatchMachine(iconUrl, matchMimeTypeToUrl);
var fileIconPngMm = new MatchMachine(iconPngUrl, matchMimeTypeToPngUrl);
var structuredMessageMm = new MatchMachine(structuredMessageUrl, matchMimeTypeToStructuredMessageUrl);
var structuredCoverMm = new MatchMachine(structuredCoverUrl, matchMimeTypeToStructuredCoverUrl);
var sharePlaceholderMm = new MatchMachine(sharePlaceholderUrl, matchMimeTypeToSharePlaceholderUrl);
var faviconUrlMm = new MatchMachine(faviconUrl, matchMimeTypeToFavicon);
//# sourceMappingURL=file-icon-url.js.map